<template>
    <div class="sys-sidebar" :style="{ width: width + 'px' }">
        <!-- 顶部品牌区（不影响业务，纯样式增强） -->
        <div class="brand" :class="{ mini: isCollapse }">
            <div class="brand-badge">
                <i class="el-icon-odometer"></i>
            </div>
            <div class="brand-text" v-show="!isCollapse">
                <div class="brand-title">控制台</div>
<!--                <div class="brand-sub">REG · CONSOLE</div>-->
            </div>
        </div>

        <!-- 菜单主体 -->
        <div class="menu-wrap custom-scroll">
            <el-menu
                    :collapse="isCollapse"
                    :default-active="activeMenu"
                    :unique-opened="true"
                    :collapse-transition="false"
                    class="menu-vertical"
            >
                <template v-for="(item,index) in nextMenuList">
                    <!-- 有子级 -->
                    <template v-if="item.list && item.list.length">
                        <el-submenu :index="index+''" :key="index">
                            <template slot="title">

                                <i  v-if="item.emoji" class="my_icon_style">{{item.emoji}}</i>
<!--                                <i class="el-icon-menu">🌿</i>-->
                                <span class="submenu-title" :title="item.name">{{ item.name }}</span>
<!--                                <span class="submenu-dot"></span>-->
                            </template>

                            <!-- 折叠态时为每个子项包一层 tooltip，展开态则不展示（disabled） -->
                            <el-tooltip
                                    v-for="(items,indexs) in item.list"
                                    :key="index + '-' + indexs"
                                    :disabled="!isCollapse"
                                    :content="items.name"
                                    placement="right"
                                    effect="light"
                            >
                                <el-menu-item
                                        :index="items.url"
                                        @click="jump(items)"
                                        class="menu-item-rich"
                                >
                                    <span class="menu-bullet"></span>
                                    <span class="menu-title" :title="items.name">{{ items.name }}</span>
                                </el-menu-item>
                            </el-tooltip>
                        </el-submenu>
                    </template>

                    <!-- 无子级 -->
                    <template v-else>
                        <el-tooltip :disabled="!isCollapse" :content="item.name" placement="right" effect="light">
                            <el-menu-item
                                    :index="item.url"
                                    :key="'s-' + index"
                                    @click="jump(item)"
                                    class="menu-item-rich"
                            >
<!--                                <i class="el-icon-menu"></i>-->
                                <i  v-if="item.emoji" class="my_icon_style">{{item.emoji}}</i>
                                <span class="menu-title" :title="item.name">{{ item.name }}</span>
                            </el-menu-item>
                        </el-tooltip>
                    </template>
                </template>
            </el-menu>
        </div>

        <!-- 底部折叠按钮（不改动原逻辑，只优化样式） -->
        <div class="collapse">
            <button class="collapse-btn" type="button" @click="changeCollapse">
                <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
                <span class="collapse-text" v-show="!isCollapse">收起侧栏</span>
            </button>
            <div class="footer-shadow"></div>
        </div>

        <!-- 背景装饰（渐变 + 噪点 + 波形） -->
        <div class="sidebar-bg">
            <div class="bg-gradients"></div>
            <div class="bg-noise"></div>
            <div class="bg-waves"></div>
            <!-- 可选图片角标（示意用，可替换你的 LOGO PNG/SVG） -->
            <div class="bg-stamp"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sys-sidebar",
        data() {
            return {
                width: 240,
                isCollapse: false
            };
        },
        computed: {
            activeMenu() {
                return this.$route.path;
            },
            nextMenuList() {
                return [
                  {
                    "id": 82,
                    "parentId": 24,
                    "name": "缺值筛选",
                    "url": "/push/miss",
                    "type": 0,
                    "orderNum": 0,
                    "delFlag": 0
                  },
                  {
                    "id": 83,
                    "parentId": 24,
                    "name": "浓度异常低值",
                    "url": "/push/low",
                    "type": 0,
                    "orderNum": 1,
                    "delFlag": 0
                  },
                  {
                    "id": 84,
                    "parentId": 24,
                    "name": "数据异常稳定-变异系数",
                    "url": "/push/variation",
                    "type": 0,
                    "orderNum": 2,
                    "delFlag": 0
                  },
                  {
                    "id": 85,
                    "parentId": 24,
                    "name": "异常标记",
                    "url": "/push/abnormal",
                    "type": 0,
                    "orderNum": 3,
                    "delFlag": 0
                  },
                  {
                    "id": 86,
                    "parentId": 24,
                    "name": "涉嫌拔管行为",
                    "url": "/push/decannulation",
                    "type": 0,
                    "orderNum": 4,
                    "delFlag": 0
                  },
                  {
                    "id": 87,
                    "parentId": 24,
                    "name": "未按照固定氧含量折算",
                    "url": "/push/oxygen",
                    "type": 0,
                    "orderNum": 5,
                    "delFlag": 0
                  }
                ]
            },
            FMenuList: {
                get() {
                    return this.$store.state.user.FMenuList;
                },
                set(val) {
                    this.$store.commit("updateFMenuList", val);
                }
            }
        },
        methods: {
            changeCollapse() {
                if (this.isCollapse) {
                    this.width = 240;
                } else {
                    this.width = 60;
                }
                this.isCollapse = !this.isCollapse;
            },
            jump(item) {
                try {
                    if (item && item.list) {
                        this.FMenuList = item.list;
                    }
                    const to = (item && item.url) || "/";
                    // 重复路由跳转保护
                    if (to && to !== this.$route.path) {
                        this.$router.push({ path: to });
                    }
                } catch (e) {
                    // 静默失败，保证侧栏不因异常阻塞
                    // console.warn('[sidebar.jump] error:', e)
                }
            }
        }
    };
</script>

<style scoped lang="less">
    /* ---- 主题基底：浅色清爽 + 多层装饰背景 ---- */
    .sys-sidebar {
        height: 100%;
        position: relative;
        background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
        border-right: 1px solid #eef2f7;
        box-shadow: inset -1px 0 0 rgba(24, 39, 75, 0.03);
        overflow: hidden;
        transition: width 0.25s ease;
    }

    /* 顶部品牌区 */
    .brand {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 18px 14px 12px 14px;
        position: relative;
        z-index: 1;
        &.mini {
            justify-content: center;
            padding: 16px 0 8px;
        }
    }
    .brand-badge {
        width: 36px;
        height: 36px;
        border-radius: 12px;
        background: radial-gradient(120% 120% at 10% 10%, #e6f1ff 0%, #eaf7ff 45%, #ffffff 100%);
        border: 1px solid #e8eef7;
        display: grid;
        place-items: center;
        box-shadow: 0 4px 14px rgba(80, 120, 255, 0.12);
        i {
            color: #5a7be7;
            font-size: 18px;
        }
    }
    .brand.mini .brand-badge {
        width: 38px;
        height: 38px;
    }
    .brand-text {
        .brand-title {
            font-weight: 600;
            color: #27364a;
            font-size: 14px;
            letter-spacing: 0.2px;
        }
        .brand-sub {
            font-size: 12px;
            color: #91a1b4;
            margin-top: 2px;
        }
    }

    /* 菜单包裹区 + 自定义滚动条 */
    .menu-wrap {
        height: calc(100% - 120px);
        padding: 6px 6px 60px 6px;
        position: relative;
        z-index: 1;
    }
    .custom-scroll {
        overflow: auto;
    }
    .custom-scroll::-webkit-scrollbar {
        width: 8px;
    }
    .custom-scroll::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.08);
        border-radius: 8px;
    }
    .custom-scroll:hover::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.12);
    }

    /* Element-UI 菜单美化 */
    ::v-deep .menu-vertical {
        background: transparent;
        border-right: 0;
    }

    /* 一级标题（有子级）右侧小圆点装饰 */
    .submenu-title {
        color: #344767;
        font-size: 14px;
        font-weight: 600;
    }
    .submenu-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-left: auto;
        background: linear-gradient(135deg, #bcd5ff 0%, #dfeaff 100%);
        border: 1px solid #e6efff;
    }

    /* 子项与无子级项的“丰富”视觉 */
    .menu-item-rich {
        position: relative;
        border-radius: 10px;
        margin: 6px 10px;
        padding-left: 10px !important;
        transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.02s ease;
    }

    /* 左侧细条指示（hover 和 active 时出现） */
    .menu-item-rich::before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 8px;
        width: 3px;
        border-radius: 3px;
        background: transparent;
        transition: background 0.2s ease;
    }

    /* 项目标题文字 */
    .menu-title {
        color: #3b4a62;
        font-size: 13px;
        letter-spacing: 0.2px;
    }

    /* 小圆点 bullets（层次） */
    .menu-bullet {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 8px;
        background: #e2eaf6;
        border: 1px solid #eaf0fb;
    }

    /* 悬浮态 */
    ::v-deep .el-menu-item.menu-item-rich:hover {
        /*background: #f4f8ff;*/
        background: linear-gradient(180deg, #c4e5ff 0%, #bed7ff 100%) !important;
        box-shadow: 0 1px 0 rgba(80, 120, 255, 0.04) inset;
    }
    ::v-deep .el-menu-item.menu-item-rich:hover::before {
        background: #9cc3ff;
    }

     /*选中态 */
    ::v-deep .el-menu-item.is-active {
        background: linear-gradient(180deg, #a0c4ff 0%, #8db9ff 100%) !important;
        box-shadow: inset 0 0 0 1px #d8e8ff;
        border-radius: 10px;
    }


    ::v-deep .el-menu-item.is-active::before {
        background: #5a8fff;
    }
    ::v-deep .el-menu-item.is-active .menu-title {
        color: #2f5ec4;
        font-weight: 600;
    }


 /*   !* —— 增强选中态（选中项更加突出） —— *!
    ::v-deep .el-menu-item.is-active {
        background: linear-gradient(180deg, #a0c4ff 0%, #8db9ff 100%) !important; !* 更明显的渐变背景 *!
        border-radius: 10px;
        box-shadow: inset 0 0 8px rgba(80, 120, 255, 0.2);  !* 添加内阴影，让选中项更立体 *!
    }

    ::v-deep .el-menu-item.is-active .menu-title {
        color: #2d4f9d !important; !* 强调选中项的文字颜色 *!
        font-weight: bold;         !* 强调文字 *!
    }

    !* 左侧高亮条更加显眼 *!
    ::v-deep .el-menu-item.is-active::before {
        background: #3a75ff;   !* 更显眼的条形高亮 *!
    }

    !* —— 高亮效果：提高对比度 —— *!
    ::v-deep .el-submenu.is-active > .el-submenu__title {
        background: #e3f0ff !important;  !* 子菜单选中时背景色对比增强 *!
        color: #2d4f9d; !* 文字颜色 *!
        box-shadow: inset 0 0 5px rgba(80, 120, 255, 0.3);
    }

    ::v-deep .el-submenu.is-active > .el-submenu__title:hover {
        background: #b3d4ff !important;  !* 悬停时的轻微变化 *!
    }
*/


    /* 一级菜单标题 hover/active */
    ::v-deep .el-submenu__title {
        margin: 6px 6px;
        min-height: 42px;
        height: auto;
        line-height: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;
        align-items: flex-start;
        border-radius: 10px;
        color: #344767;
        font-weight: 600;
        transition: background 0.2s ease, box-shadow 0.2s ease;
    }
    ::v-deep .el-submenu__title:hover {
        background: linear-gradient(180deg, #c4e5ff 0%, #bed7ff 100%) !important;
        box-shadow: 0 0 0 1px #eef4ff inset;
    }

    /* 展开后的子菜单背景更柔和 */
    ::v-deep .el-menu--inline {
        background: transparent !important;
        padding-left: 6px;
    }

    /* 折叠按钮区域 */
    .collapse {
        position: absolute;
        bottom: 8px;
        left: 0;
        right: 0;
        display: grid;
        place-items: center;
        pointer-events: none;
        z-index: 1;
    }
    .footer-shadow {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 58px;
        height: 24px;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 70%);
    }
    .collapse-btn {
        pointer-events: auto;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 14px;
        border: 1px solid #e6ecf5;
        background: #ffffff;
        border-radius: 12px;
        cursor: pointer;
        box-shadow: 0 6px 16px rgba(28, 76, 186, 0.08);
        transition: box-shadow 0.2s ease, transform 0.05s ease;
    }
    .collapse-btn i {
        font-size: 18px;
        color: #4e6ae6;
    }
    .collapse-btn:hover {
        box-shadow: 0 8px 20px rgba(28, 76, 186, 0.12);
    }
    .collapse-btn:active {
        transform: translateY(1px);
    }
    .collapse-text {
        color: #5c6f8a;
        font-size: 12px;
    }

    /* —— 折叠态：让图标绝对居中 —— */
    ::v-deep .el-menu--collapse {
        width: 100% !important;
    }

    /* 去掉折叠态的左侧内边距，用 flex 居中 */
    ::v-deep .el-menu--collapse > .el-submenu > .el-submenu__title,
    ::v-deep .el-menu--collapse > .el-menu-item {
        padding: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 44px;
        line-height: 44px;
        margin: 6px 8px;
        border-radius: 12px;
    }

    /* 图标本身去掉默认外边距 */
    ::v-deep .el-menu--collapse > .el-submenu > .el-submenu__title i,
    ::v-deep .el-menu--collapse > .el-menu-item i {
        margin: 0 !important;
        font-size: 18px;
    }

    /* 隐藏折叠态下的标题与装饰点（保留 DOM，让弹出层能显示文字） */
    ::v-deep .el-menu--collapse > .el-submenu > .el-submenu__title .submenu-title,
    ::v-deep .el-menu--collapse > .el-submenu > .el-submenu__title .submenu-dot,
    ::v-deep .el-menu--collapse > .el-menu-item .menu-title {
        display: none !important;
    }

    /* 隐藏子菜单的小箭头，避免偏移 */
    ::v-deep .el-menu--collapse > .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
        display: none !important;
    }

    /* 折叠时隐藏左侧高亮条，避免占位造成“看起来不居中” */
    ::v-deep .el-menu--collapse > .el-menu-item.menu-item-rich::before {
        display: none !important;
    }

    /* 弹出层（挂在 body 上）确保文字显示、层级与可读性 */
    ::v-deep .el-menu--popup .menu-title,
    ::v-deep .el-menu--popup .submenu-title {
        display: inline !important;
        opacity: 1 !important;
        visibility: visible !important;
    }
    ::v-deep .el-menu--popup {
        min-width: 168px;
        z-index: 2010;
        box-shadow: 0 10px 28px rgba(16, 44, 112, 0.12);
        border: 1px solid #e9eff8;
        border-radius: 10px;
        background: #fff;
    }
    ::v-deep .el-menu--popup .el-menu-item,
    ::v-deep .el-menu--popup .el-submenu__title {
        padding: 0 14px;
    }

    /* 展开态：长标题换行展示，避免文字被截断 */
    ::v-deep .el-menu-item.menu-item-rich {
        min-height: 42px;
        height: auto !important;
        line-height: 20px !important;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;
        align-items: flex-start;
    }

    .menu-title,
    .submenu-title {
        max-width: 170px;
        white-space: normal;
        word-break: break-all;
        overflow: visible;
        text-overflow: unset;
        display: inline-block;
        line-height: 20px;
    }

    /* 细节：图标与文字颜色统一 */
    ::v-deep .el-menu-item i,
    ::v-deep .el-submenu__title i {
        color: #7b8ca8;
    }

    /* ---------------- 背景装饰层 ---------------- */
    .sidebar-bg {
        pointer-events: none;
        position: absolute;
        inset: 0;
        overflow: hidden;
    }

    /* 1) 多层柔和辐射渐变光斑 */
    .bg-gradients {
        position: absolute;
        inset: -20% -10% 0 -10%;
        background:
                radial-gradient(300px 160px at 85% 10%, rgba(120, 170, 255, 0.25) 0%, rgba(255, 255, 255, 0) 70%),
                radial-gradient(260px 180px at 10% 35%, rgba(109, 194, 255, 0.18) 0%, rgba(255, 255, 255, 0) 75%),
                radial-gradient(220px 140px at 40% 75%, rgba(150, 220, 255, 0.12) 0%, rgba(255, 255, 255, 0) 80%);
        mix-blend-mode: normal;
        opacity: 0.9;
    }

    /* 2) 纹理噪点（DataURI SVG） */
    .bg-noise {
        position: absolute;
        inset: 0;
        opacity: 0.06;
        background-image: url("data:image/svg+xml;utf8,\
  <svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'>\
    <filter id='n'>\
      <feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/>\
      <feColorMatrix type='saturate' values='0'/>\
      <feComponentTransfer><feFuncA type='table' tableValues='0 0 0.8 0'/></feComponentTransfer>\
    </filter>\
    <rect width='120' height='120' filter='url(%23n)' opacity='0.6'/>\
  </svg>");
        background-size: 240px 240px;
        pointer-events: none;
    }

    /* 3) 右上角波形装饰（DataURI SVG + mask） */
    .bg-waves {
        position: absolute;
        top: -4px;
        right: -40px;
        width: 240px;
        height: 160px;
        opacity: 0.25;
        background-image: url("data:image/svg+xml;utf8,\
  <svg xmlns='http://www.w3.org/2000/svg' width='320' height='220' viewBox='0 0 320 220'>\
    <defs>\
      <linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>\
        <stop offset='0%' stop-color='%23e8f1ff'/>\
        <stop offset='100%' stop-color='%23dfeaff'/>\
      </linearGradient>\
    </defs>\
    <path d='M0,180 C80,140 120,220 200,180 C260,150 290,190 320,170 L320,0 L0,0 Z' fill='url(%23g)'/>\
  </svg>");
        background-size: cover;
        mask-image: radial-gradient(180px 120px at 60% 40%, #000 60%, transparent 100%);
    }

    /* 4) 左下角印章/贴纸（可替换为你的 LOGO） */
    .bg-stamp {
        position: absolute;
        left: -18px;
        bottom: 72px;
        width: 120px;
        height: 120px;
        opacity: 0.12;
        transform: rotate(-8deg);
        background-image: url("data:image/svg+xml;utf8,\
  <svg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'>\
    <defs>\
      <linearGradient id='lg' x1='0' y1='0' x2='1' y2='1'>\
        <stop offset='0%' stop-color='%23cfe3ff'/>\
        <stop offset='100%' stop-color='%23eaf2ff'/>\
      </linearGradient>\
    </defs>\
    <circle cx='80' cy='80' r='70' fill='url(%23lg)' stroke='%23cddcf5' stroke-width='2'/>\
    <text x='80' y='88' text-anchor='middle' font-family='Arial' font-size='18' fill='%23607ecb'>REG</text>\
  </svg>");
        background-size: contain;
        background-repeat: no-repeat;
    }

    /* 可根据需要切换“低调模式”（只保留轻微渐变） */
    /*
    .sys-sidebar.lowkey .bg-noise,
    .sys-sidebar.lowkey .bg-waves,
    .sys-sidebar.lowkey .bg-stamp { display: none; }
    */




    .my_icon_style{
        font-style: normal;
        margin-right: 5px;
        font-size: 18px;
        width: 28px;
        display: inline-block;
    }



</style>
